// extracted by mini-css-extract-plugin
export default {"avatarRoot":"Avatar-module_avatarRoot_nEgo51","avatarImage":"Avatar-module_avatarImage_jt4Me1","avatarFallback":"Avatar-module_avatarFallback_VwAaY4"};